/*
 * @Description: file content
 * @Author:
 * @Date: 2024-11-26 10:09:14
 * @LastEditors: Xiaochun liu
 * @LastEditTime: 2024-11-26 17:02:25
 */

import { defineStore } from 'pinia'

import { store } from '@/store'

import { getWorkspaces } from '@/api'
import { getLibStatus } from '@/features/knowledgeBase/api/lib'

export interface workspaceItem {
  enterpriseRole: null | number // 企业角色 0：普通成员 1：管理员
  workspaceName: string
  workspaceId: number | null
  workspaceType: WorkspaceType
  isManager?: boolean
  balance?: number
  permissions: number[] | null
  companyTypeClassifyList: string[]
  introductionFile: null // 公司介绍资料
  introductionStatus: 0 // 公司介绍资料状态 0：未填写 1：已填写
  menus: string[]
  vipState?: number // 认证状态  1=已认证 10-vip企业 20-svip企业 90-svip定制
  logo?: string // 企业logo
}

export enum WorkspaceType {
  Personal = 0,
  Company = 1,
  Check = -1,
}

export const useWorkspaceStore = defineStore('workspace-store', {
  state: () => {
    return {
      workspaceType: WorkspaceType.Personal,
      workspaceList: [] as workspaceItem[],
      enterpriseKnowledgeBaseId: 0,

      currentWorkspace: {
        workspaceName: '',
        workspaceId: null,
        workspaceType: WorkspaceType.Personal,
        companyTypeClassifyList: [] as string[],
        menus: [] as string[],
      } as workspaceItem,
      showCreateCompanyModal: false,
    }
  },
  actions: {
    async updateWorkspaceList() {
      return getWorkspaces().then((res: workspaceItem[]) => {
        this.workspaceList = res.map((item: workspaceItem) => {
          return {
            ...item,
            workspaceId: item.workspaceId,
          }
        })

        if (!this.currentWorkspace?.workspaceName) {
          const companyArr = this.workspaceList?.filter((item: workspaceItem) => item.workspaceType === WorkspaceType.Company)
          if (companyArr?.length) {
            // 空间列表有企业，选中第一个企业
            this.currentWorkspace = companyArr[0]
          } else if (this.workspaceList.length) {
            // 空间列表没有企业，选中第一个空间
            this.currentWorkspace = this.workspaceList[0]
          } else {
            // 没有空间列表
            this.currentWorkspace = {
              workspaceName: '',
              workspaceId: null,
              workspaceType: WorkspaceType.Personal,
            }
          }
        }
        // 根据当前空间 id获取企业知识库id
        const workspaceId = this.currentWorkspace.workspaceId
        if (workspaceId) {
          getLibStatus({ enterpriseId: workspaceId }).then((res) => {
            this.enterpriseKnowledgeBaseId = res.find((item: { libType: number }) => item.libType === 4)?.knowledgeBaseId || 0
            // console.log(this.enterpriseKnowledgeBaseId, 'this.enterpriseKnowledgeBaseId')
          })
        }
      })
    },
    updateWorkspaceType(workspaceType: WorkspaceType) {
      this.workspaceType = workspaceType
    },
    async updateCurrentWorkspace(workspace: workspaceItem) {
      if (this.workspaceList.length === 0) {
        await this.updateWorkspaceList()
      }
      this.updateWorkspaceType(workspace.workspaceType)
      this.currentWorkspace = workspace
    },
    async updateCurrentWorkspaceById(id: number | null) {
      if (this.workspaceList.length === 0) {
        await this.updateWorkspaceList()
      }

      const workspace = this.workspaceList.find((item: workspaceItem) => item.workspaceId === id)

      if (workspace) {
        this.updateWorkspaceType(workspace.workspaceType)
        this.updateCurrentWorkspace(workspace)
      }
    },
    getWorkspaceById(id: number) {
      return this.workspaceList.find((item: workspaceItem) => item.workspaceId === id)
    },
    updateCreateCompanyModal(isCreateCompanyModal: boolean) {
      this.showCreateCompanyModal = isCreateCompanyModal
    },
  },
  getters: {
    permissionsMenus(state) {
      return state.currentWorkspace.menus
    },
    hasMarketAgentPermission(state) {
      return state.currentWorkspace.menus.includes('MARKET_AGENT')
    },
    isPersonal(state) {
      return state.currentWorkspace.workspaceType === WorkspaceType.Personal
    },
    allWorkspaceList(state) {
      return [...toRaw(state.workspaceList)]
    },
    workspaceId(state) {
      return state.currentWorkspace?.workspaceId
    },
    enterpriseId(state) {
      return state.currentWorkspace?.workspaceId
    },
    isCurrentWorkspaceAdmin(state) {
      return state.currentWorkspace.enterpriseRole === 1
    },
    isCreateCompanyModal(state) {
      return state.showCreateCompanyModal
    },
    /** 是否有个人空间 */
    hasPersonal(state) {
      return state.workspaceList.some((item: workspaceItem) => item.workspaceType === WorkspaceType.Personal)
    },
    // 企业类型
    enterpriseTypes(state) {
      return state.currentWorkspace.companyTypeClassifyList
    },
  },
})

export function useWorkspaceStoreWithout() {
  return useWorkspaceStore(store)
}
